<template>
     <div class="popup" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="bookingDetailVisa">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p> </p>
            <a class="shorexDetail-returnButton" @click="onGoBack">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail">
            <div class="packageRuleDetail">
                
                <div class="rule-item">
                    <div class="rule-item-title"><div class="rule-item-title-line"></div>游轮保险</div>
                    <div class="rule-item-text" v-if="cruiseVisa">
                        <div class="visa_desc" v-html="cruiseVisa.insuranceContent">
                        </div>
                    </div>
                </div>
                <div class="rule-item" v-if="isShowSpecialBooking">
                    <div class="rule-item-title"><div class="rule-item-title-line"></div>生日礼遇退改规则</div>
                    <div class="rule-item-text" v-if="cruiseVisa">
                        <p>开航前7天（不含）之前，可以免费修改生日礼遇的乘客信息（仅限同舱内）、调整享用生日蛋糕的用餐时间或取消生日礼遇；开航前7天之内，不再接受任何修改或取消，已取消的费用不予退回。</p>
                    </div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title"><div class="rule-item-title-line"></div>办理登船注意事项</div>

                    <div class="rule-item-text rule-item-text2">
                        <div class="reservation_desc">
                            <p>
                                1） 支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理在线值船，打印“登船证”并于登船当天携带。如遇紧急情况，请您拨打400-820-7293 。
                            </p>
                            <p>
                                2） 码头办理登船时间为出发港口登船当日当地时间 {{boardingTime}} ，请您务必于该时间段内抵达码头办理登船，否则将影响您的出行。
                            </p>

                            <p>
                                3）{{portName}}码头地址：{{portAddress}}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "BookingDetailVisa",
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        },
        cruiseVisa: {
            type: Object
        },
        boardingTime: {
            type: String
        },
        portAddress: {
            type: String
        },
        portName: {
            type: String
        },
        isShowSpecialBooking:{
            type: Boolean,
            default () {
                return false
            }
        }
    }
}
</script>

<style lang="less" scoped>
#bookingDetailVisa.popup {
    position: fixed;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
    overflow-y: hidden;
}
#bookingDetailVisa.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#bookingDetailVisa.modal-out {
    transform: translate3d(100%, 0, 0);
}

#bookingDetailVisa {
    li {
        list-style: none;
    }
    .shorexDetail-title {
        padding: 0px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        height: 50px;
        > p {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }
    }

    .ruleDetail {
        margin-top: 60px;
        height: 100%;
        overflow: scroll;
        padding-bottom: 60px;
        .rule-item {
            padding: 0 20px 12px;
            font-size: 12px;
            line-height: 20px;
            color: #666;
            letter-spacing: 0;
            background-color: #fff;
            .rule-item-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding: 17px 0 7px;
                font-size: 14px;
                line-height: 20px;
                color: #4A90E2;
                font-weight: bold;
                .rule-item-title-line {
                    width: 3px;
                    height: 12px;
                    margin-right: 6px;
                    background-color: #4A90E2;
                }
            }
        }
    }
    
}

</style>

<style lang="less">
#bookingDetailVisa .rule-item .rule-item-text p {
    margin: 0px;
    font-weight: 500;
}
</style>